import { STORY, IMAGES } from "../mock/mock";
import useReveal from "../hooks/useReveal";

export default function About() {
  const [ref, inView] = useReveal();

  return (
    <section id="histoire" className="bg-white py-16 md:py-24">
      <div
        ref={ref}
        className={`max-w-4xl mx-auto px-5 md:px-8 text-center ${inView ? "reveal in-view" : "reveal"}`}
      >
        <img
          src={IMAGES.authorPortrait}
          alt="Gérard Trèves, le pèlerin la Tortue"
          width="402"
          height="412"
          loading="lazy"
          decoding="async"
          className="mx-auto h-32 w-32 md:h-40 md:w-40 rounded-full object-cover shadow-lg ring-4 ring-[#5c2751]/10"
        />
        <p className="mt-8 font-heading text-xl md:text-2xl font-bold italic text-[#5c2751]">
          {STORY.quote}
        </p>
        <div className="mt-6 space-y-5 text-[15px] md:text-base leading-relaxed text-[#6c6c6c] text-left">
          {STORY.paragraphs.map((p) => (
            <p key={p}>{p}</p>
          ))}
        </div>
      </div>
    </section>
  );
}
